import { Component, OnInit, OnDestroy, Output, ViewChild, ElementRef }  from '@angular/core';
import { Router, ROUTER_DIRECTIVES, ActivatedRoute } from '@angular/router';
import {INewYearRolloverSteps, INewYearRollOverRequest, INewYearRollOverResponse, INewYearRollOverDisplayList, INewYearRollOverDisplayElem} from './new-year-rollover-steps';
import {NewYearRolloverStepsService} from './new-year-rollover-steps.service';

import {SystemControl} from '../../../shared/system-control';
import {SystemControlElem} from '../../../shared/system-control-elem';
import { SystemControlService} from '../../../shared/system-control.service';

import { Dialog } from 'primeng/primeng';
import {Messages} from 'primeng/primeng';
@Component({
    //templateUrl: 'app/system-management/new-year-rollover/new-year-rollover-steps/new-year-rollover-steps.component.html',
    template: require('./new-year-rollover-steps.component.html'),
    //styleUrls: ["../../../../node_modules/awesome-bootstrap-checkbox/awesome-bootstrap-checkbox.css"],
    styles: [require('../../../styles/awesome-bootstrap-checkbox.css')],
    directives: [ROUTER_DIRECTIVES, Dialog, Messages],
    providers:[NewYearRolloverStepsService,SystemControlService]
})


export class NewYearStepsComponent implements OnInit, OnDestroy{
    pageTitle: string = 'New Year Steps';
    errorMessage: string;
    private sub: any;
    newYearSteps: INewYearRolloverSteps;
    newYearResponse: INewYearRollOverResponse;
    newYearRequest: INewYearRollOverRequest; 
    fyYear:number;
    lfyYearInput: HTMLInputElement;
    newYearRolloverList:any;
    displaySpinner :boolean=false;
    msgs: Messages[]=[];

    @Output() systemControl:SystemControl;
    @ViewChild('newForecastYearField') newForecastYearField: ElementRef;

    constructor(private route: ActivatedRoute,
                private router: Router,
                private _newYearRolloverService:NewYearRolloverStepsService,
                private _systemControlService:SystemControlService) {
                this.systemControl = new SystemControl(_systemControlService);
                this.newYearRequest = new INewYearRollOverRequest(this.systemControl.importStage);
    }

    
    ngOnInit(): void{
        this.newYearRolloverList=[new INewYearRollOverDisplayElem ({stepNumber:1, stepName: 'ManagerLock', stepDescription:''}),
        new INewYearRollOverDisplayElem ({stepNumber:2, stepName: 'Set up New Year Rollover', 
            stepDescription:'The following tasks will be completed: Delete all scenario with id >1 Populate SAVED RATES Set Regional Input to false if regional input end year is less than first forecast year'}),
        new INewYearRollOverDisplayElem ({stepNumber:3, stepName: 'EMDF/NPIAS Facility Data Preparation', stepDescription:' Before running step 3 make sure EMDF/NPIAS tables are populated in database. The following steps must be completed before import is permitted:Comparison list between TAF and EMDF/NPIAS prepared FAA revisions to the list made FAA revisions incorporated into import'}),
        new INewYearRollOverDisplayElem ({stepNumber:4, stepName: 'Import EMDF/NPIAS Facility Data', stepDescription:' Check New Year Rollover Reports before running step 4.'}),
        new INewYearRollOverDisplayElem ({stepNumber:5, stepName: ' for OPSNet facilities', stepDescription:'Bring in OPSNet tower data before running step 5.'}),
        new INewYearRollOverDisplayElem ({stepNumber:6, stepName: 'Tracon Ops Import for OPSNet facilities ', stepDescription:'Bring in OPSNet TRACON data before running step 6.'}),
        new INewYearRollOverDisplayElem ({stepNumber:7, stepName: 'NFDC Data Preparation  - Facilities, Facility Detail', stepDescription:'The following steps must be completed before import is permitted: Comparison list between TAF and NFDC prepared APO revisions to the list made APO revisions incorporated into import'}),
        new INewYearRollOverDisplayElem ({stepNumber:8, stepName: 'Import NFDC Data - AOPS, Based Aircraft  ', stepDescription:'The following tasks will be completed:  Import facilities Import facility details for all facilities Import AOPS for non-OPSNet facilities Import Based Aircraft for all facilities'}),
        new INewYearRollOverDisplayElem ({stepNumber:9, stepName: 'Enplanements Preparation', stepDescription:'The following tasks will be completed: Mark enplanment forecasts for this fiscal year as history'}),
        new INewYearRollOverDisplayElem ({stepNumber:10, stepName: 'System Release', stepDescription:'The following steps must be completed before import is permitted: Find all facilities that have operations records that were not updated from forecast to history for the current fiscal year. Report to APO all facilities that still have forecasts for the current fiscal year. Get determination from APO on how to proceed. Based on APO feedback, set forecast years to history for the current fiscal year. '}),
        new INewYearRollOverDisplayElem ({stepNumber:11, stepName: 'Reforecast National Scenario based on stored rates ', stepDescription:''}),
        ]
    }
 
    setLfcYear():void{
             this.newYearRequest.lfcYear = this.newForecastYearField.nativeElement.value;
    }
    runSteps():void{

        if( this.systemControl.importStage != 2) this.newYearRequest.lfcYear = this.systemControl.lfcYear;
        this.newYearRequest.fyYear = this.systemControl.fyYear;
        this.newYearRequest.stepNumber = this.systemControl.importStage;
        // alert("lfcYear " + this.systemControl.lfcYear +"/"+ this.newYearRequest.lfcYear);
        // alert("stepNumber"  + this.systemControl.importStage +"/"+ this.newYearRequest.stepNumber);
        this.displaySpinner = true;
        this._newYearRolloverService.newYearRollOverRunSteps(this.newYearRequest)
                .subscribe(
                    newYearResponse => this.newYearResponse = newYearResponse,
                    error =>{ this.errorMessage = error;
                        this.msgs.push({severity:'error', summary:'Error Message', detail:this.newYearResponse.message +" "+ this.errorMessage });
                    },
                    ()=>{
                        if( this.newYearResponse.message.indexOf("Error")>=0){
                            this.msgs.push({severity:'error', summary:'Error Message', detail:this.newYearResponse.message});
                        }
                        else{
                            this.msgs.push({severity:'info', summary:'Info Message', detail:this.newYearResponse.message});
                        }
                        this.systemControl = new SystemControl(this._systemControlService);
                        this.displaySpinner = false;
                        //console.log("newYear Response Message: " + this.newYearResponse.message);
                    }
        );
    }

    ngOnDestroy() {
        //alert("onDestroy");
        //this.sub.unsubscribe();
   }
   
}


/** WEBPACK FOOTER **
 ** ./app/system-management/new-year-rollover/new-year-rollover-steps/new-year-rollover-steps.component.ts
 **/